<script setup lang="ts">
import AuthAvatar from '@/auth/components/AuthAvatar.vue';
import SiteSelect from '@/sites/components/SiteSelect.vue';
import SettingsIcon from './SettingsIcon.vue';
import UndoButton from 'shared/undo/components/UndoButton.vue';
import { useThemeStore } from 'shared/themes/stores/themeStore';

import { useDarkMode } from 'shared/themes/composables/darkMode';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import lightLogo from "@/assets/TiYard_logo.png"
import darkLogo from "@/assets/TiYard_logo_dark.png"

const tiyardLogoPath = computed(() => {
  return enabled.value ? darkLogo : lightLogo
})

const themeStore = useThemeStore();
const theme = themeStore.currentTheme;
console.log(theme);

const darkMode = useDarkMode();
const { enabled } = storeToRefs(darkMode);

</script>

<template>
  <header class="shadow">
    <div v-if="theme === 'SILog'" class="header-title text-xl">
      <span>SI</span>
      <span class="text-primary">Log</span>
      <span> Cloud</span>
    </div>
    <div v-if="theme === 'Fleetskill'" class="header-title text-xl">
      <span>FleetInfo Cloud</span>
    </div>
    <div v-if="theme === 'TILog'" class="header-title">
      <img width="175" :src="tiyardLogoPath" alt="TiYard logo" />
    </div>

    <div class="header-actions">
      <UndoButton></UndoButton>
      <slot></slot>
      <SiteSelect></SiteSelect>
      <AuthAvatar></AuthAvatar>
      <SettingsIcon></SettingsIcon>
    </div>

  </header>

</template>

<style scoped>
header {
  display: grid;
  grid-template-columns: auto 1fr;
  padding-inline: .5rem;
  padding-block: .5rem;
  column-gap: .5rem;
  grid-row: 1;
  grid-column: 1/3;
  z-index: 2;
}

.header-title {
  grid-column: 1;
  align-self: center;
}

.header-title span {
  font-weight: 700;
}

.header-actions {
  display: flex;
  flex-direction: row;
  justify-content: end;
  column-gap: 0.5rem;
  align-items: center;
  grid-column: 2;
}

.p-dark header {
  background-color: var(--p-surface-800);
}
</style>
